module.exports = __webpack_public_path__ + "img/start_marker.d1a41aa0.png";